// src/services/StudyProgramService.js
import api from "./api";

export function getStudyProgram(page = 1, limit = 10, search = "") {
  return api.get(`/studyprogram?page=${page}&limit=${limit}&search=${search}`);
}

export function getStudyProgramById(id) {
  return api.get(`/studyprogram/${id}`);
}

export function addStudyProgram(data) {
  return api.post("/studyprogram", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateStudyProgram(id, data) {
  return api.put(`/studyprogram/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteStudyProgram(id) {
  return api.delete(`/studyprogram/${id}`);
}

export function uploadStudyProgram(formData) {
  return api.post("/studyprogram/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    transformRequest: [(data) => data], // ⭐ important
  });
}

export function getDeletedStudyPrograms(page = 1, limit = 10, search = "") {
  return api.get(`/studyprogram/deleted?page=${page}&limit=${limit}&search=${search}`);
}

export function restoreStudyProgram(id) {
  return api.put(`/studyprogram/restore/${id}`);
}

export function hardDeleteStudyProgram(id) {
  return api.delete(`/studyprogram/hard/${id}`);
}
